<template>
  <v-dialog v-model="dialog" persistent width="780px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>delete</v-icon> Rechazar papeleta a cuenta de vacación
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-container grid-list-md class="pt-0">
          <v-layout row wrap>
            <v-flex xs12>
              <h3><strong>Número:</strong> {{ permiso.numero }}</h3>
            </v-flex>
            <v-flex xs12>
              <h3><strong>Servidor público:</strong> {{ permiso.nombres }}</h3>
            </v-flex>
            <v-flex xs12>
              <h3>
                <strong>Tipo de papeleta:</strong> {{ permiso.tipo_permiso }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 8">
              <h3>
                <strong>Lugar de atencion:</strong> {{ permiso.lugar_atencion }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 87">
              <h3><strong>Lugar de comisión :</strong> {{ permiso.lugar }}</h3>
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == 87 || permiso.id_tipo_permiso == 96
              "
            >
              <h3><strong>Motivo:</strong> {{ permiso.motivo }}</h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 90">
              <h3><strong>Tipo de baja:</strong> {{ permiso.motivo }}</h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <h3>
                <strong>Fecha de nacimiento:</strong>
                {{ permiso.fecha_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '61'">
              <h3>
                <strong>Hora de nacimiento:</strong>
                {{ permiso.hora_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <h3>
                <strong>Fecha de fallecimiento:</strong>
                {{ permiso.fecha_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '6'">
              <h3>
                <strong>Hora de fallecimiento:</strong>
                {{ permiso.hora_nac_muerte }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == '12'">
              <h3>
                <strong>Fecha de matrimonio:</strong>
                {{ $moment(permiso.fecha_nac_muerte).format("DD-MM-YY") }}
              </h3>
            </v-flex>
          </v-layout>

          <v-flex xs12>
            <h3><strong>Detalles de papeleta.</strong></h3>
          </v-flex>
          <v-layout>
            <v-flex xs12>
              <!-- permisos por horas -->
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_horas"
                v-if="
                  permiso.id_tipo_permiso == 87 ||
                    permiso.id_tipo_permiso == 96 ||
                    permiso.id_tipo_permiso == 88 ||
                    (permiso.id_tipo_permiso >= 37 &&
                      permiso.id_tipo_permiso <= 43)
                "
              >
                >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.horas_permiso }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias decimales -->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_dias_decimales"
                v-if="
                  permiso.id_tipo_permiso == 14 ||
                    (permiso.id_tipo_permiso >= 98 &&
                      permiso.id_tipo_permiso <= 101) ||
                    permiso.id_tipo_permiso == 89 ||
                    permiso.id_tipo_permiso == 18
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias completos-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_dias"
                v-if="
                  permiso.id_tipo_permiso == 6 ||
                    permiso.id_tipo_permiso == 44 ||
                    permiso.id_tipo_permiso == 95 ||
                    permiso.id_tipo_permiso == 61 ||
                    permiso.id_tipo_permiso == 12 ||
                    permiso.id_tipo_permiso == 90
                "
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.nro_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos 94 formulario de registro de asistencias-->
          <v-layout v-if="permiso.id_tipo_permiso == 94">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_registro_asistencias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_retorno }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!--permiso 24-->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles"
                class="elevation-1"
                hide-actions
                :headers="headers"
                v-if="permiso.id_tipo_permiso == '24'"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_desde }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td v-if="props.item.rango_horario == 1">Solo mañana</td>
                  <td v-if="props.item.rango_horario == 2">Solo tarde</td>
                  <td v-if="props.item.rango_horario == 0">Todo el día</td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

          <h3
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <strong>Detalles compensacion</strong>
          </h3>
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
            "
          >
            <v-flex xs12>
              <v-data-table
                :items="permiso_compensacion"
                class="elevation-1"
                hide-actions
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.diferencia_horas }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout class="pa-2">
            <v-flex xs12>
              <h4
                v-if="
                  permiso.id_tipo_permiso == 88 || permiso.id_tipo_permiso == 96
                "
              >
                <strong>Total horas: {{ total_horas_acomuladas }}</strong>
              </h4>
            </v-flex>
          </v-layout>
          <v-flex xs12>
            <h3><strong>Seguimiento de la papeleta</strong></h3>
          </v-flex>
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :headers="headers_seg_detalle"
                :items="detalle_seguimiento"
                class="elevation-1"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item._created_at).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.estado.descripcion }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      props.item.usuario
                        ? props.item.usuario.nombre_usuario
                        : ""
                    }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md12s>
              <v-textarea
                v-model="permiso.justificacion_rechazo"
                @input="validacionBoton()"
                class="v_card"
                rows="1"
                label="Justificación del rechazo"
                background-color="rgba( 117, 109, 194 ,0.4)"
                :rules="$validate(['required'])"
                required
                outline
                success
                clearable
              >
              </v-textarea>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secundary" @click.prevent="close()" :loading="loading"
          ><v-icon>close</v-icon>
          Cancelar
        </v-btn>

        <v-btn
          color="error"
          :disabled="bandera_boton"
          @click.prevent="apruebaRechazaPermiso(permiso)"
          ><v-icon>clear</v-icon>
          Rechazar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  components: {},
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogRechazarPermisoCtaVacacion", async item => {
      this.permiso = item;

      this.total_horas();
      this.cargarDetallesPermiso();
      // Obtnemos el correo del servidor seleccionado
      this.datos_usuario = await this.obtieneDatosPersona(
        this.permiso.id_funcionario
      );
      this.verPermisosCompensacion(parseInt(this.permiso.id_permiso));
      this.permiso.motivo_rechazo = "";
      this.getDetallePermiso(parseInt(this.permiso.id_permiso));
      this.getDetalleSeguimiemto(parseInt(this.permiso.id_permiso));
      this.dialog = true;
    });
  },
  data() {
    return {
      dialog: false,
      bandera_boton: true,
      datos_usuario: null,
      permiso: {
        motivo_rechazo: ""
      },
      permiso_detalles2: [],
      permiso_compensacion: [],
      permiso_detalles: [],
      detalle_seguimiento: [],
      total_horas_acomuladas: 0,
      loading: false,
      horas_solicitadas_comp: 0,
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        // {
        // 	text: 'Hora desde',
        // 	sortable: false,
        // 	align: 'center'
        // },
        // {
        // 	text: 'Hora hasta',
        // 	sortable: false,
        // 	align: 'center'
        // },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_seg_detalle: [
        // { text: 'Número', sortable: false, align: 'center'},
        { text: "Fecha de registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario Registro", sortable: false, align: "center" }
      ],

      horas_solicitadas: 0
    };
  },
  methods: {
    async cargarDetallesPermiso() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
			    query{
					vPermisosPorFuncionarios(id_permiso:"${this.permiso.id_permiso}"){
					rows{
						id_permiso
							id_persona
							nombres
							numero
							fecha_desde
							fecha_emision
							tipo_permiso
							fecha_retorno
							estado_permiso
							nro_dias
							hora_desde
							hora_hasta
							id_lugar
							lugar_atencion
							fecha_nac_muerte
							hora_nac_muerte
							tipo_nac_muerte
							rango_horario
							rechazo
							horas_permiso
							id_tipo_permiso
							compensa_tolerancia
							permiso{
							id
							motivo
							id_tipo_permiso
							ruta_archivo
							tipo_permiso{
								id
								id_parametro_elaborado
							}
							fecha_permiso
							numero
							fecha_registro
							id_estado
							lugar        
							
							estado{
								descripcion
							}
							
							
							}
						}
			}
				}
              `
        });
        this.permiso_detalles2 = respuesta.vPermisosPorFuncionarios.rows;
      } catch (error) {
        console.log(error);
      }
    },
    validacionBoton() {
      if (this.permiso.justificacion_rechazo) {
        this.bandera_boton = false;
      } else {
        this.bandera_boton = true;
      }
    },
    async obtieneDatosPersona(id_persona) {
      try {
        let usuario = null;
        let respuesta = await this.$service.graphql({
          query: `
          query{
              runQuery(consulta:"select u.correo,u.nombre_usuario,up.id_persona,u.id as id_usuario,p.ap_paterno,p.ap_materno,p.nombres from seguridad.usuario_persona up join seguridad.usuario u  on up.id_usuario =u.id join persona.persona p on up.id_persona =p.id  where up.id_persona =  ${id_persona}"){
                respuesta
              }
            }
          `
        });
        respuesta = respuesta.runQuery.respuesta;
        if (respuesta.length > 0) {
          usuario = respuesta[0];
        }
        return usuario;
      } catch (error) {
        console.log(error);
      }
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });

        this.permiso_compensacion = respuesta.runQuery.respuesta;
        this.sumar_horas_compensa(this.permiso_compensacion);
      } catch (error) {
        console.log(error);
      }
    },
    sumar_horas_compensa(permiso_detalles) {
      let total_comp = 0;
      permiso_detalles.forEach(item => {
        total_comp +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas_comp = total_comp;
    },
    close() {
      this.dialog = false;
      this.permiso = {
        motivo: ""
      };
      this.$bus.$emit("closeDialog");
    },

    sumar_horas(permiso_detalles) {
      let total = 0;
      permiso_detalles.forEach(item => {
        total +=
          this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
            item.fecha_desde + " " + item.hora_desde,
            "minutes"
          ) / 60;
      });
      this.horas_solicitadas = total;
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
    async getDetallePermiso(id) {
      try {
        let res = await this.$service.graphql({
          query: `
             query{
              vDetallePermisos(lista_estados:"9,6,7,16,21",id_permiso:${id}){
                rows{
                  id
                  id_permiso
                  id_estado_detalle
                  fecha_desde
                  fecha_hasta
                  fecha_desde_compensa
                  hora_desde
                  hora_hasta
                  horas_compensa
                  fecha_permiso
				  total_dias
				  rango_horario
                }
              }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
         let respuesta 
        let res 
        respuesta= await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `,
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
         res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `,
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async apruebaRechazaPermiso(permiso) {
      try {
        if (!permiso.justificacion_rechazo) {
        return;
      }
      const user = this.$storage.get("user");
      let respuesta = "";
      respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_rechazo_permisos_por_jefes_rrhh(${permiso.id_permiso},${user.id},'${permiso.justificacion_rechazo}','','{}')"){
                  respuesta
                }
              }
            `
          });

          let resp = respuesta.runQuery.respuesta[0].fn_rechazo_permisos_por_jefes_rrhh;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fué rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }

      } catch (error) {
        console.log(error)
      }
    },
    async apruebaRechazaPermisoOld(permiso, id_estado) {
      const user = this.$storage.get("user");
      let respuesta = "";
      if (this.permiso.id_tipo_permiso == 24) {
        try {
          respuesta = await this.$service.graphql({
            query: `
                                        query{
                                          runQuery(consulta:"select control.fn_aprueba_cta_vacacion(${permiso.id_permiso},'${id_estado}','${user.id_persona}','${user.id}','${this.permiso.justificacion_rechazo}')"){
                                            respuesta
                                          }
                                        }
                                      `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_cta_vacacion;

          let resps = resp.split("|");
          let correcto = resps[0];
          if (correcto == "1") {
            //enviamos el correo al funcionario:
            if (this.datos_usuario) {
              var mensaje = `
              <h1>NOTIFICACIÓN - RECHAZO DE PAPELETA A CUENTA DE VACACIÓN</h1>
              Estimado(a): ${this.datos_usuario.nombres} ${this.datos_usuario.ap_paterno} ${this.datos_usuario.ap_materno}<br>
              Su papeleta a cuenta de vacación fue rechazada por el siguiente motivo: ${this.permiso.justificacion_rechazo} . `;
              await this.$service.sendEmail({
                correo: this.datos_usuario.correo,
                asunto: `NOTIFICACIÓN - RECHAZO DE PAPELETA A CUENTA DE VACACIÓN`,
                mensaje: mensaje.replace(/<[^>]+>/g, ""),
                html: mensaje
              });
            } else {
              this.$message.info(
                "No se notifico por correo ya que el servidor no posee un correo registrado"
              );
            }
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          } else {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      this.close();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/papeleta_vacacion/dialogs/RechazarPermiso.vue